import React from 'react'
import PropTypes from 'prop-types'

import { map, startsWith } from 'lodash'

import { Link } from 'react-router-dom'

import { routing } from '../redux'

const TabBar = ({ tabs, url }) => (
    <div className="tab-container">
        <ul className="nav nav-tabs">
            { map(tabs, ({ title, route }) => {
                const isActive = startsWith(url, route)
                return (
                    <li className={ isActive ? 'active' : null } key={ title }>
                        <Link to={ route }>
                            { title }
                        </Link>
                    </li>
                )
            }) }
        </ul>
    </div>
)

TabBar.propTypes = {
    tabs : PropTypes.arrayOf(PropTypes.object),
    url  : PropTypes.string.isRequired
}

export default routing.withRouter(TabBar)
